import React from "react";

const DeliveryInformationPage: React.FC = () => {
  return <div>DeliveryInformation</div>;
};

export default DeliveryInformationPage;
